function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  overflow: hidden;\n  width: 100%;\n  padding: 0 45px;\n  text-align: center;\n  background: #fff;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  font-size: 15px;\n  line-height: 18px;\n  font-weight: bold;\n  padding-bottom: 18px;\n  color: #47494c;\n  margin-top: 10px;\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  font-size: 13px;\n  line-height: 20px;\n  color: #6d747b;\n  padding-bottom: 28px;\n  max-width: 346px;\n  margin: 0 auto !important;\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  font-size: 24px;\n  line-height: 28px;\n  color: #47494c;\n  font-weight: bold;\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  appearance: none;\n  border: none;\n  padding: 0;\n  background-color: transparent;\n  font-size: 13px;\n  cursor: pointer;\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  font-size: 13px;\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  &:before,\n  &:after {\n    background-color: #000;\n  }\n"
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { forwardRef } from 'react';
import styled from 'styled-components';
// eslint-disable-next-line import/no-unresolved
import { useObserver } from 'mobx-react-lite';
import { Text } from '@dutchie/common/components/rebass-compat';
import { ModalClose, ModalButton } from 'shared/modals';
import { ModalContainer } from 'shared/modals/v2-container';
import useStores from 'shared/hooks/use-stores';
var PhoneNumberConfirmationModal = /*#__PURE__*/ forwardRef(function(param, ref) {
    var containerProps = param.containerProps;
    var onConfirm = function onConfirm(result) {
        UI.phoneNumberConfirmationObj.confirmed = true;
        resolve(result);
        UI.phoneNumberConfirmationObj.open = false;
    };
    var _useStores = useStores(), UI = _useStores.UI, User = _useStores.User, Cart = _useStores.Cart;
    var resolve = UI.phoneNumberConfirmationObj.resolve;
    var customerPhone = Cart.order.guestCustomer ? Cart.order.guestCustomer.phone : User.profile.phone;
    return useObserver(function() {
        if (!UI.phoneNumberConfirmationObj.open) {
            return null;
        }
        return /*#__PURE__*/ _jsxs(ModalContainer, _object_spread_props(_object_spread({
            ref: ref,
            padding: "31px 0px 45px 0px",
            scrollable: true,
            isOpen: true,
            width: 495,
            "data-cy": "confirm-number-modal",
            "data-test": "confirm-number-modal",
            "data-testid": "confirm-number-modal"
        }, containerProps), {
            children: [
                /*#__PURE__*/ _jsxs(ModalContent, {
                    children: [
                        /*#__PURE__*/ _jsx(StyledModalHeader, {
                            children: "Confirm Your Phone Number"
                        }),
                        /*#__PURE__*/ _jsx(StyledText, {
                            children: "It's important that we have the correct mobile phone number in case we need to contact you about your order."
                        }),
                        /*#__PURE__*/ _jsx(LargeText, {
                            "data-testid": "customer-phone-number",
                            children: customerPhone
                        }),
                        /*#__PURE__*/ _jsx(StyledModalButton, {
                            "aria-label": "Place Order",
                            "data-cy": "confirm-place-order",
                            "data-test": "confirm-place-order",
                            "data-testid": "confirm-place-order",
                            onClick: function() {
                                onConfirm(true);
                            },
                            m: "13px auto 30px",
                            p: "0 30px",
                            children: "Confirm"
                        }),
                        /*#__PURE__*/ _jsx(Link, {
                            onClick: function() {
                                onConfirm(false);
                            },
                            children: "It's wrong! I need to fix it."
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(StyledModalClose, {
                    onClick: function() {
                        return onConfirm(false);
                    }
                })
            ]
        }));
    });
});
export default PhoneNumberConfirmationModal;
var ModalContent = styled.div(_templateObject());
var StyledModalHeader = styled.h3(_templateObject1());
var StyledText = styled(Text)(_templateObject2());
var LargeText = styled(Text)(_templateObject3());
var Link = styled.button(_templateObject4());
var StyledModalButton = styled(ModalButton)(_templateObject5());
var StyledModalClose = styled(ModalClose)(_templateObject6());
